import { RTL_LANGUAGES, SUPPORTED_APP_LANGUAGES } from '@shared/appConstants';

const alternateCodes: Record<string, (typeof SUPPORTED_APP_LANGUAGES)[number]> = {
  nb: 'no',
  nn: 'no',
};

let requestedLocale: string | null = null;

// tries to set the requested locale from the query string
export const loadRequestedLocale = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const locale = params.get('locale');
    if (locale && SUPPORTED_APP_LANGUAGES.includes(locale)) {
      requestedLocale = locale;
    }
  } catch (e) {
    console.warn(e);
  }
};

export const getRequestedLocale = () => requestedLocale;

export const getNavigatorLanguage = () => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const langs = navigator.languages || [navigator.language];
  for (const lang of langs) {
    const code = lang.slice(0, 2);
    const canonicalCode = alternateCodes[code] ?? code;
    if (SUPPORTED_APP_LANGUAGES.includes(canonicalCode)) {
      return canonicalCode;
    }
  }
  return null;
};

export const isRtlLocale = (localeCode: string) => {
  //remove region from locale to handle ar-SA case
  return RTL_LANGUAGES.includes(localeCode.split('-')[0]!);
};

export const getLocaleDirection = (localeCode: string) => (isRtlLocale(localeCode) ? 'rtl' : 'ltr');
